function formatNumberToString(value, n = 2) {
  var str = '' + parseInt(value || 0, 10)

  if (n <= str.length) {
    return str
  }

  var list = []
  for (var i = 0, len = n - str.length; i < len; i++) {
    list.push('0')
  }
  return list.join('') + str
}

const filters = {
  showKeyValueListText(value, list, $k = 'value', $v = 'label') {
    let text = ''
    list.forEach(item => {
      if (value == item[$k]) text = item[$v]
    })
    return text
  },

  bigNumberFormat(value, fix = 2, str = 'W') {
    value = +value
    if (value < 10000) return value
    return window.$utils.newToFixed(value / 10000, fix) + str
  },

  dateFormat(time, fmt) {
    return window.$utils.dateFormat(time, fmt)
  },
  toPercent(value, count) {
    if (count == 0) return '0.00'
    return ((value * 100) / count).toFixed(2)
  },
  videoDuration(value = 0, showHour = false) {
    value = +value
    let hour = parseInt(value / 3600),
      minutes = parseInt((value % 3600) / 60),
      seconds = parseInt(value % 60)

    if (hour < 10) hour = '0' + hour
    if (minutes < 10) minutes = '0' + minutes
    if (seconds < 10) seconds = '0' + seconds
    if (showHour) {
      return hour + ':' + minutes + ':' + seconds
    } else {
      return minutes + ':' + seconds
    }
  },
  textCount(value, count) {
    let len = 0
    if (typeof value == 'string') {
      len = Math.ceil(window.$utils.strlen(value) / 2)
    }
    if (value instanceof Array) {
      len = value.length
    }
    return len + '/' + count
  },
  bitNumber(num, digits) {
    const si = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'K' },
      { value: 1e6, symbol: 'M' },
      { value: 1e9, symbol: 'G' },
      { value: 1e12, symbol: 'T' },
      { value: 1e15, symbol: 'P' },
      { value: 1e18, symbol: 'E' }
    ]
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
    let i
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break
      }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
  },
  numCount(value, count) {
    let len = value ? value.length : 0
    return len + '/' + count
  },
  formatSeconds(value, type = 1) {
    let second = parseInt(value)
    let minute = 0
    let hour = 0
    let result

    if (type == 1) {
      if (second > 60) {
        minute = ~~(second / 60)
        second = ~~(second % 60)
        if (minute > 60) {
          hour = ~~(minute / 60)
          minute = ~~(minute % 60)
        }

        result = second < 10 ? '0' + second : second

        if (minute > 0) {
          result = (minute < 10 ? '0' + minute : minute) + ':' + result
        }

        if (hour > 0) {
          result = (hour < 10 ? '0' + hour : hour) + ':' + result
        }
      } else {
        result = '00:' + formatNumberToString(second)
      }

      return result
    } else if (type == 2) {
      if (second > 60) {
        minute = ~~(second / 60)
        second = ~~(second % 60)
        if (minute > 60) {
          hour = ~~(minute / 60)
          minute = ~~(minute % 60)
        }
      }
      let result = '' + (second < 10 ? '0' + second : second) + '秒'
      if (minute > 0) {
        result = '' + (minute < 10 ? '0' + minute : minute) + '分' + result
      }
      if (hour > 0) {
        result = '' + (hour < 10 ? '0' + hour : hour) + '小时' + result
      }
      return result
    } else if (type == 3) {
      if (second > 60) {
        minute = ~~(second / 60)
        second = ~~(second % 60)
      }
      let result = '' + (second < 10 ? '0' + second : second) + '秒'
      if (minute > 0) {
        result = '' + (minute < 10 ? '0' + minute : minute) + '分' + result
      }
      return result
    }
  }
}
export default filters
